import { SelectOptionProps } from '@acceso/design-system';

import { useProductionCenters } from '../api/get-production-centers';

export function useProductionCenterOptions(): SelectOptionProps<string>[] {
  const { data: { data: productionCenters = [] } = {} } = useProductionCenters();
  const options: SelectOptionProps<string>[] = productionCenters.map(productionCenter => ({
    label: productionCenter.name,
    value: productionCenter.id,
  }));

  return options;
}
